import React, { useCallback, useEffect, useState } from 'react';
import { Button } from "../../../components/Button/Button";
import { MonthPicker } from "../../../components/DatePicker/MonthPicker";
import { Divider } from "../../../components/Divider/Divider";
import { Grid } from "../../../components/Grid/Grid";
import { Popup } from "../../../components/Popup/Popup";
import { PopupContent } from "../../../components/Popup/PopupContent";
import { Select } from "../../../components/Select/Select";
import { TextField } from "../../../components/TextField/TextField";
import { Typography } from "../../../components/Typography/Typography";
import { useTranslation } from "../../../hooks/useTranslation";
import { makeStyles } from "../../../styles/index";
import { allKyokaDrillTypeItem, useSelectionDrillType } from "../hooks/useSelectionDrillType";
import { FilterCondition } from "../models/Work/FilterCondition";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        margin: theme.spacing(0, 3, 0, 1),
        lineHeight: 0,
    },
    row: {
        margin: theme.spacing(1, 0),
    },
    filterAction: {
        margin: theme.spacing(0, 1),
    },
}); }, { name: 'SnWorkSelectFilter' });
/**
 * ワークのフィルターコンポーネント
 */
export var WorkSelectFilter = React.memo(function (props) {
    var open = props.open, filterCondition = props.filterCondition, anchorEl = props.anchorEl, schoolType = props.schoolType, onFilterSelect = props.onFilterSelect, onFilterClear = props.onFilterClear, onCloseFilter = props.onCloseFilter;
    var _a = useState(''), name = _a[0], setName = _a[1];
    var _b = useState(null), createdFromMonth = _b[0], setCreatedFromMonth = _b[1];
    var _c = useState(null), createdToMonth = _c[0], setCreatedToMonth = _c[1];
    var _d = useState(allKyokaDrillTypeItem.value), drillType = _d[0], setDrillType = _d[1];
    /**
     * ログインユーザーの学校種で利用可能なワークメーカーのドリルタイプの配列を返す
     */
    var drillTypeItems = useSelectionDrillType(schoolType);
    var t = useTranslation().t;
    var classes = useStyles();
    useEffect(function () {
        if (!open)
            return;
        setName(filterCondition.name);
        setCreatedFromMonth(filterCondition.createdFromMonth);
        setCreatedToMonth(filterCondition.createdToMonth);
    }, [filterCondition, open]);
    var handleChangeName = useCallback(function (inputTitle) {
        setName(inputTitle);
    }, []);
    var handleChangeCreatedFromMonth = useCallback(function (inputCreatedFromMonth) {
        setCreatedFromMonth(inputCreatedFromMonth);
    }, []);
    var handleChangeCreatedToMonth = useCallback(function (inputCreatedToMonth) {
        setCreatedToMonth(inputCreatedToMonth);
    }, []);
    var handleChangeDrillType = useCallback(function (value) {
        setDrillType(Number(value));
    }, []);
    var handleClose = useCallback(function () {
        onCloseFilter();
    }, [onCloseFilter]);
    var handleClickClear = useCallback(function () {
        onFilterClear();
    }, [onFilterClear]);
    var handleClickFilter = useCallback(function () {
        onFilterSelect(new FilterCondition({
            name: name,
            createdFromMonth: createdFromMonth,
            createdToMonth: createdToMonth,
            drillType: drillType,
        }));
    }, [onFilterSelect, name, createdFromMonth, createdToMonth, drillType]);
    return (React.createElement("div", { className: classes.root },
        React.createElement(Popup, { open: open, anchorEl: anchorEl, width: 720, onClickAway: handleClose, placement: "bottom-end" },
            React.createElement(PopupContent, null,
                React.createElement(Grid, { container: true, alignItems: "center", className: classes.row },
                    React.createElement(Grid, { item: true, xs: 2 },
                        React.createElement(Typography, { variant: "body1" }, t('ワーク名'))),
                    React.createElement(Grid, { item: true, xs: 10 },
                        React.createElement(TextField, { placeholder: t('ワーク名を入力'), dense: true, value: name, onInput: handleChangeName, maxLength: 100 }))),
                React.createElement(Grid, { container: true, alignItems: "center", className: classes.row },
                    React.createElement(Grid, { item: true, xs: 2 },
                        React.createElement(Typography, { variant: "body1" }, t('作成月'))),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(MonthPicker, { value: createdFromMonth, onChange: handleChangeCreatedFromMonth, disableFuture: true })),
                    React.createElement(Grid, { item: true, xs: 1 },
                        React.createElement(Typography, { align: "center" }, t('から'))),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(MonthPicker, { value: createdToMonth, onChange: handleChangeCreatedToMonth, disableFuture: true })),
                    React.createElement(Grid, { item: true, xs: 1 },
                        React.createElement(Typography, { align: "center" }, t('まで')))),
                React.createElement(Grid, { container: true, alignItems: "center", className: classes.row },
                    React.createElement(Grid, { item: true, xs: 2 },
                        React.createElement(Typography, { variant: "body1" }, t('教科'))),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Select, { dense: true, onChange: handleChangeDrillType, value: drillType !== null && drillType !== void 0 ? drillType : 0, selectItems: drillTypeItems, width: 230 })))),
            React.createElement(Divider, null),
            React.createElement(PopupContent, null,
                React.createElement(Grid, { container: true, justify: "flex-end" },
                    React.createElement(Button, { className: classes.filterAction, variant: "square", onClick: handleClickClear }, t('クリア')),
                    React.createElement(Button, { className: classes.filterAction, variant: "square", onClick: handleClickFilter, fill: true }, t('検索')))))));
});
